import classNames from 'classnames/bind';

import { useSelector } from 'react-redux';
import Breadcrumbs from '../BreadCrumbs';
import { countryList } from '../../../data/filing';

import withComponentName from '../../../decorators/withComponentName';
import withMetatag from '../../../decorators/metadataDecorators/metatagsTitleDecorator';

import Styles from './styles.module.scss';
import PlayVideoComponent from '../../PlayVideoComponent';

const cx = classNames.bind(Styles);

const Filing = ({ history, match }) => {
  const onRowSelect = ({ ticker }) => {
    history.push(`/directory/filings/${ticker}`);
  };
  const { searchBarActive } = useSelector((state) => state.searchReducers);

  return (
    <div className={cx(Styles.filings, searchBarActive && Styles.blurred)}>
      <Breadcrumbs match={match} />
      <div className={Styles.filings_header}>
        Official Company Filings
        <PlayVideoComponent
          videoLink="https://cityfalcon.wistia.com/medias/zj9uvpl28w"
          videoLinkMobile="https://cityfalcon.wistia.com/medias/2p8zwc1y1e"
        />
      </div>
      <div className={Styles.filings_header_details}>
        <p>
          Public companies and private companies both file official documents
          and statements with financial regulators and industry agencies around
          the world to prove their financial state. Our sources include RNS feeds
          from the LSE and Companies House and data from the SEC Edgar system. Here
          we deliver filings in full-text PDF format, and our machines have extracted
          and organised the most important parts for simplified research.&nbsp;
          <a
            href="https://www.cityfalcon.ai/features/filings"
            target="_blank"
            rel="noreferrer noopener"
          >
            Learn more.
          </a>
        </p>
      </div>
      <div className={Styles.fillings_country_list}>
        {countryList.map((country) => (
          <CountryListComponent
            key={country.id}
            isMore={country.isMore}
            ticker={country.ticker}
            name={country.name}
            image={country.image}
            onRowSelect={onRowSelect}
          />
        ))}
      </div>
    </div>
  );
};

const CountryListComponent = ({
  name, image, isMore, ticker, onRowSelect,
}) => {
  const rowClass = cx(Styles.country_row, isMore && Styles.country_row_more);

  const handleRowClick = () => {
    if (isMore) return;
    onRowSelect({ ticker });
  };

  return (
    <div className={rowClass} onClick={handleRowClick}>
      {
        image
          ? <img alt="" src={image} width={30} height={30} loading="lazy" />
          : <div className={Styles.country_more} />
      }
      <div className={Styles.country_row_text}>{name}</div>
    </div>
  );
};

export default withMetatag(
  withComponentName(Filing),
  'directory/filings',
);
